import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer, SafeHtml, SafeUrl } from '@angular/platform-browser';
import {
  INotificationBoxItem,
  INotificationLink,
} from '@shared/types/ui/components';
import { Router } from '@angular/router';

/**
 * EXAMPLE OF USAGE
 *
 *
 * HTML CONTENT
 * {
 *  type: NotificationContentType.HTML,
 *  htmlString: '<span>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</span>',
 *  wrapItem: true,   <- common field, set <br> before content item (by default - false)
 * } as INotificationHTML,
 *
 * LINK CONTENT (external link)
 * {
 *  type: NotificationContentType.LINK,
 *  link: 'some-link.com',
 *  isExternalLink: true,   <- change it to false to link as Angular Router (by default - false)
 *  isBlankRedirect: true,   <- change it to false to change target of link for '_self'
 *  title: 'Link',
 * } as INotificationLink,
 *
 * LINK CONTENT (angular router link)
 * {
 *  type: NotificationContentType.LINK,
 *  link: ['/', 'package'],
 *  closeAfterRedirect: true,  <- change it to false to do not delete notification after redirect
 *  title: 'Package',
 * } as INotificationLink,
 *
 * BUTTON CONTENT
 * {
 *  type: NotificationContentType.BUTTON,
 *  title: 'Some button',
 *  callBack: closeNotificationFunc,  <- callBack function on click
 *  linkView: true,   <- drop button styles and set link styles (by default - false)
 * } as INotificationButton,
 * this.uiActions.addNotification(notification);
 */

@Component({
  selector: 'xvi-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationItemComponent {
  @Input() public notification: INotificationBoxItem;

  public constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {}

  public sanitizeHTMLStringValue(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  public sanitizeUrlStringValue(value: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(value);
  }

  public redirect(notificationLinkContent: INotificationLink): void {
    this.router.navigate(notificationLinkContent.link as any[]);
    if (notificationLinkContent.closeAfterRedirect) {
      this.closeNotification();
    }
  }

  public onNotificationClick(): void {
    this.notification?.onClick?.();
  }

  public onNotificationMouseover(): void {
    this.notification?.onHover?.();
  }

  private closeNotification(): void {
    if (this.notification.closeNotification) {
      this.notification.closeNotification(this.notification.id);
    }
  }
}
